import React from 'react';
import '../styles/Privacy.css';

const Privacy = () => {
  return (
    <div className="privacy-container">
      <div className="privacy-header">
        <h1>Privacy Policy</h1>
        {/* <p className="effective-date">Effective Date: 22/09/2025</p> */}
      </div>

      <div className="privacy-content">
        <section className="privacy-section">
          <p className="welcome-text">
            Welcome to Mpeoples.in mobile application ("App"). We are committed to protecting your privacy and providing a safe and transparent user experience. This Privacy Policy explains how we collect, use, share, and protect your information when you use our App, website, or related services.
          </p>
        </section>

        <section className="privacy-section">
          <h2>Information We Collect</h2>
          <div className="section-content">
            <div className="info-item">
              <h3>Personal Information:</h3>
              <p>When you interact with our App, we may collect personal information such as your name, email address, and other details you provide voluntarily.</p>
            </div>
            
            <div className="info-item">
              <h3>Usage Data:</h3>
              <p>We automatically collect data about how you use the App, including your device type, operating system, IP address, pages/screens visited, and app interactions.</p>
            </div>
            
            <div className="info-item">
              <h3>Device Identifiers:</h3>
              <p>To serve personalized ads and improve services, we may collect unique device identifiers (e.g., Advertising ID or IDFA) and app usage statistics.</p>
            </div>
            
            <div className="info-item">
              <h3>Cookies and Tracking Technologies:</h3>
              <p>We may use cookies, local storage, or similar technologies to improve your experience and analyze app usage.</p>
            </div>
            
            <div className="info-item">
              <h3>API Data:</h3>
              <p>Our App fetches data from third-party services, such as Fuel Prices APIs and RapidAPI, to provide relevant information. Please note that when using APIs from RapidAPI, your request data (such as IP address, usage statistics, or query information) may be collected and processed according to RapidAPI's Privacy Policy.</p>
            </div>
          </div>
        </section>

        <section className="privacy-section">
          <h2>How We Use Your Information</h2>
          <div className="section-content">
            <div className="info-item">
              <h3>To Provide and Improve Services:</h3>
              <p>We use your information to deliver app functionality, display fuel prices, show personalized content, and improve our App experience.</p>
            </div>
            
            <div className="info-item">
              <h3>To Serve Ads:</h3>
              <p>We use collected information and device identifiers to display targeted ads via AdMob and other third-party ad networks.</p>
            </div>
            
            <div className="info-item">
              <h3>To Communicate:</h3>
              <p>We may send you updates, promotions, or important notifications about the App. You can opt out of marketing communications at any time.</p>
            </div>
            
            <div className="info-item">
              <h3>For Analytics and Improvements:</h3>
              <p>We analyze app usage data to improve performance, user experience, and understand how features are used.</p>
            </div>
          </div>
        </section>

        <section className="privacy-section">
          <h2>How We Share Your Information</h2>
          <div className="section-content">
            <div className="info-item">
              <h3>With Service Providers:</h3>
              <p>We share your information with trusted third-party providers who help operate our App, such as hosting, analytics, advertising partners, and API providers like RapidAPI. These providers are obligated to use your information only for the purposes specified by us and subject to their own privacy policies.</p>
            </div>
            
            <div className="info-item">
              <h3>For Legal Reasons:</h3>
              <p>We may disclose your information if required by law, to protect our rights, or to ensure safety of our users.</p>
            </div>
            
            <div className="info-item">
              <h3>In Business Transfers:</h3>
              <p>If our company undergoes a merger, acquisition, or sale, your information may be transferred as part of the business assets.</p>
            </div>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Third-Party Services and Privacy Policies</h2>
          <div className="section-content">
            <p>Our App relies on third-party services that may collect, process, or store information in order to provide certain features. Please review their privacy policies for more details:</p>
            
            <div className="third-party-links">
              <div className="link-item">
                <strong>RapidAPI (API provider):</strong>
                <a href="https://rapidapi.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://rapidapi.com/privacy
                </a>
              </div>
              
              <div className="link-item">
                <strong>Google Analytics for Firebase (usage analytics):</strong>
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
              </div>
              
              <div className="link-item">
                <strong>AdMob (advertising):</strong>
                <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">
                  https://policies.google.com/privacy
                </a>
              </div>
            </div>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Important Notes About Third Parties</h2>
          <div className="section-content">
            <p>While our App, Services, and Site may integrate or link to content and data from external providers through APIs or embedded links, these third-party websites, services, and advertisements are not operated or controlled by us. Some may display our name or logo for branding purposes, but their data practices are governed by their own privacy policies, not ours.</p>
            
            <p>This Privacy Policy only explains how we collect, use, and share your information within our App, Services, and Site. We are not responsible for any collection, usage, or disclosure of data by third parties outside our control. If you leave our App or interact with third-party content, the privacy policies of those providers will apply.</p>
            
            <div className="info-item">
              <h3>Advertisements:</h3>
              <p>When you use our App or visit our Site, you may see advertisements served by third-party networks. These companies may use information (excluding personally identifiable details like your name, email, or phone number) about your visits to our and other websites/apps to show you ads tailored to your interests.</p>
            </div>
            
            <p>We recommend reviewing the privacy practices of all third-party services before sharing any personal data with them.</p>
            
            <div className="info-item warning">
              <h3>Fuel Price Disclaimer:</h3>
              <p>The fuel prices displayed in our App are sourced from third-party APIs. Actual prices shown by fuel stations, government websites, or other sources may vary. We are not responsible for any discrepancies between the prices shown in our App and those provided by other platforms.</p>
            </div>
          </div>
        </section>

        <section className="privacy-section">
          <h2>How We Protect Your Information</h2>
          <div className="section-content">
            <p>We implement administrative, technical, and physical safeguards to protect your data. However, no method of transmission over the Internet or storage system is completely secure, and we cannot guarantee absolute security.</p>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Your Choices</h2>
          <div className="section-content">
            <div className="info-item">
              <h3>Access and Update:</h3>
              <p>You can access, update, or correct your personal information by contacting us.</p>
            </div>
            
            <div className="info-item">
              <h3>Opt-Out of Ads:</h3>
              <p>You can reset your advertising ID or disable personalized ads on your device.</p>
            </div>
            
            <div className="info-item">
              <h3>Push Notifications:</h3>
              <p>You may disable push notifications through your device settings.</p>
            </div>
            
            <div className="info-item">
              <h3>Cookies:</h3>
              <p>You can manage cookie preferences in your browser or device settings.</p>
            </div>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Children's Privacy</h2>
          <div className="section-content">
            <p>Our App is not intended for individuals under 13 years of age. We do not knowingly collect information from children. If we learn that we have collected such data, we will delete it promptly.</p>
          </div>
        </section>

        <section className="privacy-section">
          <h2>Changes to This Policy</h2>
          <div className="section-content">
            <p>We may update this Privacy Policy from time to time. Updates will be posted on our website and App. We encourage you to review this policy periodically to stay informed about how we protect your information.</p>
          </div>
        </section>

        <section className="privacy-section contact-section">
          <h2>Contact Us</h2>
          <div className="section-content">
            <p>If you have questions about this Privacy Policy or our practices, please contact us:</p>
            
            <div className="contact-info">
              <h3>Mpeoples Business Solution Private Limited</h3>
              
              <div className="contact-item">
                <strong>Address:</strong>
                <p>1/248, Raja Ganapathy Complex,<br />
                   2nd Floor, Opposite BSNL Office, Meyyanur Main Road,<br />
                   Salem -636004.</p>
              </div>
              
              <div className="contact-item">
                <strong>Email:</strong>
                <a href="mailto:mpeoplesofficial@gmail.com">mpeoplesofficial@gmail.com</a>
              </div>
              
              <div className="contact-item">
                <strong>Phone:</strong>
                <a href="tel:9487812715">9487812715</a>
              </div>
            </div>
          </div>
        </section>

        <div className="thank-you-section">
          <p>Thank you for trusting Mpeoples.in with your information.</p>
        </div>
      </div>
    </div>
  );
};

export default Privacy;